var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('b-card-header',[_c('h2',[_vm._v("Past Causes")])]),_c('b-card-body',[_c('p',[_vm._v(" None yet, but check out our featured causes! ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }